import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="404 - Page Not Found | Prajwal Halwai"
        description="Looks like this route doesn't exist."
      />

      <section className="py-28 md:py-36 text-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#CC3737]/15 border border-[#CC3737]/30 text-[#CC3737] text-2xl font-bold font-mono">
            404
          </div>

          <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">
            Looks like this route doesn't exist.
          </h1>

          <p className="text-sm sm:text-base text-[#94A3B8] max-w-md mx-auto">
            The page you are looking for might have been moved, renamed, or is temporarily unavailable.
          </p>

          <div className="pt-4 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 rounded-xl text-sm font-semibold text-white bg-[#CC3737] hover:bg-[#b52f2f] transition-all"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-xl text-sm font-medium text-white bg-[#141720] hover:bg-[#1E2432] border border-[#272E3E] transition-all"
            >
              About
            </Link>
            <Link
              to="/work"
              className="px-6 py-3 rounded-xl text-sm font-medium text-white bg-[#141720] hover:bg-[#1E2432] border border-[#272E3E] transition-all"
            >
              Work
            </Link>
            <Link
              to="/contact"
              className="px-6 py-3 rounded-xl text-sm font-medium text-white bg-[#141720] hover:bg-[#1E2432] border border-[#272E3E] transition-all"
            >
              Contact
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
